__turbopack_context__.v({
  "label": "styles-module-scss-module__jYXWbG__label",
  "tooltipContent": "styles-module-scss-module__jYXWbG__tooltipContent",
  "tooltipItem": "styles-module-scss-module__jYXWbG__tooltipItem",
});
